import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {getMessages} from './selectors'
import {escapeHtmlSymbols} from '../atUtils'

const MESSAGES_LIMIT = 3
const MESSAGE_TIMEOUT = 5000
const WARNING_TIMEOUT = 30000

const setMessages = createAction(ActionTypes.MESSAGES_SET)

let idSequence = 0

export const toastHtml = (html, isWarning = false) => (dispatch, getState) => {
    const id = idSequence++
    const oldMessages = getMessages(getState())
    let newMessages

    if (oldMessages.length < MESSAGES_LIMIT) {
        newMessages = [...oldMessages, {id, html, isWarning}]
    } else {
        newMessages = [...oldMessages.slice(1), {id, html, isWarning}]
    }

    dispatch(setMessages(newMessages))

    setTimeout(() => dispatch(closeToast(id)), isWarning ? WARNING_TIMEOUT : MESSAGE_TIMEOUT)
}

export const toast = text => dispatch => {
    const html = escapeHtmlSymbols(text)
    dispatch(toastHtml(html))
}

export const warning = text => dispatch => {
    const html = escapeHtmlSymbols(text)
    dispatch(toastHtml(html, true))
}

export const closeToast = id => (dispatch, getState) => {
    const oldMessages = getMessages(getState())
    const newMessages = oldMessages.filter(message => message.id !== id)
    dispatch(setMessages(newMessages))
}



// WEBPACK FOOTER //
// ./web/js/toasts/actions.js